import { Badge } from "@/components/ui/badge";
import { ProjectStatus } from "@/enums/project.enum";

export const unitInches = (v?: string | number | null) =>
  v === undefined || v === null || v === "" ? "—" : `${v}"`;

export const renderBadgeList = (
  items: string[] | undefined | null,
  map?: Record<string, string>
) => {
  if (!items || items.length === 0)
    return <span className="text-muted-foreground">—</span>;
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map((it) => (
        <Badge key={it} variant="secondary" className="text-xs font-normal">
          {map?.[it] || it}
        </Badge>
      ))}
    </div>
  );
};

// Calculate days remaining until review date
export const calculateDaysUntilReview = (
  reviewDate: Date | string | undefined
): number | null => {
  if (!reviewDate) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const review = new Date(reviewDate);
  review.setHours(0, 0, 0, 0);

  const diffTime = review.getTime() - today.getTime();
  const daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return daysRemaining;
};

// Get badge variant based on days remaining
export const getReviewDateBadgeVariant = (
  daysRemaining: number
): "default" | "warning" | "destructive" => {
  if (daysRemaining <= 1) return "destructive";
  if (daysRemaining <= 3) return "warning";
  return "default";
};

export const getStatusBadgeVariant = (status: ProjectStatus) => {
  switch (status) {
    case ProjectStatus.PENDING:
      return "default";
    case ProjectStatus.ON_HOLD:
      return "warning";
    case ProjectStatus.REJECTED:
      return "destructive";
    case ProjectStatus.COMPLETED:
      return "success";
    default:
      return "outline";
  }
};
